import { render, staticRenderFns } from "./PlainAddressResolver.vue?vue&type=template&id=7108d55f&"
import script from "./PlainAddressResolver.vue?vue&type=script&lang=js&"
export * from "./PlainAddressResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports